const SIZE_ORDER = ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL', 'Free Size', '32', '34', '36', '38', '40', '42'];

export const sortVariants = (variants) => {
  if (!variants || variants.length === 0) return [];
  const colorOrder = [];
  const colorMap = {};
  for (const v of variants) {
    const c = v.color || 'Other';
    if (!colorMap[c]) { colorMap[c] = []; colorOrder.push(c); }
    colorMap[c].push(v);
  }
  const sorted = [];
  for (const color of colorOrder) {
    colorMap[color].sort((a, b) => {
      const ai = SIZE_ORDER.indexOf(a.size);
      const bi = SIZE_ORDER.indexOf(b.size);
      return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi);
    });
    sorted.push(...colorMap[color]);
  }
  return sorted;
};
